import { useEffect, useState } from "react"
import EditVehicleInstanceData from "./editVehicleInstanceData"
import { Button, Col, Row } from "antd"
import VehicleInstanceData from "./vehicleInstanceData"
import { Vehicle } from "../../types/appTypes"
import _t from "../../lang/translate"
import { isValidNum } from "../../utilities/typeGuard"
import TaxCaseStore from "../../contexts/taxCaseStore"
import { renderErrorMessage } from "../messages/errorMessage"
import { getRemoteData, patchVehicle } from "../../services/vehicleService"



type Props = {
  vehicle: Vehicle | null;
  showDMRAlerts?: boolean;
}

export default function VehicleInstanceDataManager({ showDMRAlerts, vehicle }: Props) {
  const { taxCase, setTaxCase } = TaxCaseStore.useContainer()
  const [isEditing, setIsEditing] = useState(!isValidNum(taxCase.vehicle?.emissionAmount))
  const [loadingDmr, setLoadingDmr] = useState(false)

  async function refetchDmr() {
    try {
      setLoadingDmr(true)
      const { data: { data } } = await getRemoteData({ vin: taxCase.vehicle?.vin, items: ['dmr'], forceFresh: true })
      if (data?.dmr?.mapped) {
        const { data: vehicle } = await patchVehicle(taxCase.vehicle?.id ?? -1, {
          firstRegDate: data.dmr.mapped.firstRegDate,
          emissionAmount: data.dmr.mapped.emissionAmount,
          emissionUnitId: data.dmr.mapped.emissionUnitId,
          emissionUnit: data.dmr.mapped.emissionUnit,
          batteryCapacity: data.dmr.mapped.batteryCapacity,
          electricConsumption: data.dmr.mapped.electricConsumption,
          electricRange: data.dmr.mapped.electricRange,
          enrich: false
        })
        setTaxCase({
          ...taxCase, vehicle: vehicle
        })
      }
    } catch (error) {
      renderErrorMessage(error)
    } finally {
      setLoadingDmr(false)
    }
  }

  useEffect(() => {
    if (!isValidNum(vehicle?.emissionAmount)) {
      setIsEditing(true)
    }
  }, [vehicle])

  return (
    isEditing ? (
      <div className="mt-2">
        <EditVehicleInstanceData vehicle={vehicle} setIsEditing={setIsEditing} />
      </div>
    ) : (
      <div className="mt-2">
        <VehicleInstanceData vehicle={vehicle} showDMRAlerts={showDMRAlerts} />
        <Row justify="space-between">
          <Col>
            <Button loading={loadingDmr}
              type="link"
              className="pl-0 pr-0"
              onClick={refetchDmr}
            >
              {_t("update_dmr_data")}
            </Button>
          </Col>
          <Col>
            <Button
              type="link"
              className="pl-0 pr-0"
              onClick={() => setIsEditing(true)}
            >
              {_t("edit", "vehicle")}
            </Button>
          </Col>
        </Row>
      </div>
    )
  )
}
